import { Controller } from "@hotwired/stimulus"

// Hovering a day of the gross chart moves the point and the cross to it and
// shows its date, gross and change; leaving puts the point back on today.
export default class extends Controller {
  static targets = ["tip", "point", "cross"]
  static values = { points: Array, geometry: Object }

  connect() {
    this.reset = this.reset.bind(this)
    this.element.addEventListener("pointerleave", this.reset)
  }

  disconnect() {
    this.element.removeEventListener("pointerleave", this.reset)
  }

  x(index) {
    const g = this.geometryValue

    return g.l + ((g.w - g.l - g.r) * index) / g.last
  }

  show(event) {
    const index = Number(event.currentTarget.dataset.index)
    const point = this.pointsValue[index]
    const box = this.element.querySelector("svg").getBoundingClientRect()
    const scale = box.width / this.geometryValue.w || 1
    const x = this.x(index)

    this.pointTarget.setAttribute("cx", x)
    this.pointTarget.setAttribute("cy", point.y)
    this.crossTarget.setAttribute("x1", x)
    this.crossTarget.setAttribute("x2", x)
    this.crossTarget.style.opacity = "1"

    this.tipTarget.replaceChildren(...this.lines(point))
    this.tipTarget.style.left = `${Math.min(Math.max(x * scale, 100), box.width - 100)}px`
    this.tipTarget.style.top = `${point.y * scale}px`
    this.tipTarget.style.opacity = "1"
  }

  lines(point) {
    const date = document.createElement("small")
    const gross = document.createElement("b")

    date.textContent = point.date
    gross.className = "num"
    gross.textContent = point.gross

    if (!point.change) return [date, gross]

    const change = document.createElement("small")

    change.className = "num"
    change.textContent = point.change

    return [date, gross, change]
  }

  reset() {
    const last = this.pointsValue.length - 1

    this.tipTarget.style.opacity = "0"
    this.crossTarget.style.opacity = "0"
    this.pointTarget.setAttribute("cx", this.x(last))
    this.pointTarget.setAttribute("cy", this.pointsValue[last].y)
  }
}
